import { authEndpoints as auth } from '@/api/endpoints/auth';
import { invoiceEndpoints as invoice } from '@/api/endpoints/invoice';
import { declarationEndpoints as declaration } from '@/api/endpoints/declaration';

export const ENDPOINTS = { auth, invoice, declaration };
